import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Mitgliedschaft.ProfiwerberViewModel
 * Klasse für Agentur/Handelsvertreter
 * Endpoints: /api/profiwerber/agw, /api/profiwerber/mew, /api/profiwerber/sww
 */
export class ProfiwerberViewModelApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ProfiwerberViewModelApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected profiwerbernummer: string;
	/**
	 * Description: Nummer des Agentur/Handelsvertreter
	 * APIL Type: string
	 */
	get Profiwerbernummer(): string {
		return this.profiwerbernummer;
	}

	/**
	 * Description: Nummer des Agentur/Handelsvertreter
	 * APIL Type: string
	 */
	set Profiwerbernummer(value: string) {
		this.profiwerbernummer = value;
	}

	protected pruefziffer: number;
	/**
	 * Description: Prüfziffer bei Messewerber
	 * APIL Type: int32
	 */
	get Pruefziffer(): number {
		return this.pruefziffer;
	}

	/**
	 * Description: Prüfziffer bei Messewerber
	 * APIL Type: int32
	 */
	set Pruefziffer(value: number) {
		this.pruefziffer = value;
	}

	protected werbeschluessel: number;
	/**
	 * Description: Werbeschluessel der zu prüfenden Anlage
	 * APIL Type: int32
	 */
	get Werbeschluessel(): number {
		return this.werbeschluessel;
	}

	/**
	 * Description: Werbeschluessel der zu prüfenden Anlage
	 * APIL Type: int32
	 */
	set Werbeschluessel(value: number) {
		this.werbeschluessel = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ProfiwerberViewModelApi {
		return AppUtils.Helper.createFromMap(dataObject, ProfiwerberViewModelApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Profiwerbernummer = this.profiwerbernummer;
		result.Pruefziffer = this.pruefziffer;
		result.Werbeschluessel = this.werbeschluessel;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}